<template>
  <main v-if="visible" id="main" class="main-site">
    <div class="row">
      <div class="col-md-12">
        <h3 class="box-title">PARCELAMENTO POR FINANCIAMENTO SOL AGORA</h3>
      </div>
    </div>

    <Loader
      v-if="loader"
      style="margin-left: auto; margin-right: auto; display: block"
    />

    <Stepper
      :steps="this.steps"
      v-on:next="nextStep"
      v-on:previous="previousStep"
      v-model="this.currentStep"
    />

    <SolAgoraStep1
      v-if="this.cliente != null"
      :cliente="this.cliente"
      :codigoPedido="this.codigoPedido"
      :idProject="this.idProject"
      :currentStep="this.currentStep"
      :token="this.token"
      v-on:next="nextStep"
      v-on:updateConsumerData="updateConsumerData"
    />

    <SolAgoraStep2
      v-if="
        this.cliente != null &&
        this.total > 0 &&
        this.idProject &&
        this.currentStep >= 2
      "
      :total="this.total"
      :codigoPedido="this.codigoPedido"
      :idProject="this.idProject"
      :cliente="this.cliente"
      :currentStep="this.currentStep"
      :token="this.token"
      v-on:next="nextStep"
      v-on:setResultadoSimulacao="setResultadoSimulacao"
    />

    <SolAgoraStep3
      v-if="this.resultadoSimulacao != null && this.currentStep >= 3"
      :resultadoSimulacao="this.resultadoSimulacao"
      :currentStep="this.currentStep"
      v-on:previous="previousStep"
      v-on:next="nextStep"
    />

    <SolAgoraStep4
      v-if="
        this.cliente != null &&
        this.resultadoSimulacao != null &&
        this.currentStep >= 4
      "
      :total="this.total"
      :cliente="this.cliente"
      :codigoPedido="this.codigoPedido"
      :idProject="this.idProject"
      :resultadoSimulacao="this.resultadoSimulacao"
      :cepCobranca="this.cepCobranca"
      :currentStep="this.currentStep"
      :token="this.token"
      v-on:previous="previousStep"
      v-on:next="nextStep"
      v-on:setResultadoProposta="setResultadoProposta"
    />

    <SolAgoraStep5
      v-if="this.resultadoProposta != null && this.currentStep == 5"
      :currentStep="this.currentStep"
      :resultadoProposta="this.resultadoProposta"
    />
  </main>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active em versões previousStepes a 2.1.8 */ {
  opacity: 0;
}

.title-article {
  font-size: 1.5em;
}

.panel-body {
  background: #f3f9ff;
}
</style>

<script>
import Stepper from "@/components/Stepper";
import SolAgoraStep1 from "./SolAgoraStep1.vue";
import SolAgoraStep2 from "./SolAgoraStep2.vue";
import SolAgoraStep3 from "./SolAgoraStep3.vue";
import SolAgoraStep4 from "./SolAgoraStep4.vue";
import SolAgoraStep5 from "./SolAgoraStep5.vue";
import SolAgoraService from "@/services/SolAgoraService";
import CarrinhoService from "@/services/CarrinhoService";

const respostaPadraoErroGenerico =
  "Serviço indisponível, tente novamente mais tarde.";

export default {
  name: "FinancingSolAgora",
  props: {
    total: { type: Number, default: 0 },
    codigoCliente: { type: String, default: "" },
    codigoPedido: { type: String, default: "" },
    visible: { type: Boolean, default: false },
  },
  components: {
    Stepper,
    SolAgoraStep1,
    SolAgoraStep2,
    SolAgoraStep3,
    SolAgoraStep4,
    SolAgoraStep5,
  },
  data() {
    return {
      loader: false,
      lastStep: 5,
      currentStep: 1,
      steps: [
        {
          step: 1,
          title: "Dados Iniciais",
        },
        {
          step: 2,
          title: "Simulação",
        },
        {
          step: 3,
          title: "Resultado Simulação",
        },
        {
          step: 4,
          title: "Proposta",
        },
        {
          step: 5,
          title: "Resultado Proposta",
        },
      ],
      cliente: null,
      cepCobranca: null,
      token: "",
      idProject: "",
      resultadoSimulacao: null,
      resultadoProposta: null,
    };
  },
  methods: {
    load: async function () {
      this.loader = true;
      const cli_codigo = this.codigoCliente.toString().split("-")[0];

      this.cliente = await SolAgoraService.GetCliente({
        apiUrl: this.$apiUrl,
        cli_codigo,
      });

      await this.getToken();
      this.idProject = await this.GetProjectId(this.codigoPedido);

      if (this.currentStep == 1 && this.idProject) {
        this.nextStep();
      }

      this.loader = false;
    },

    async GetProjectId() {
      const pev_codigo = this.codigoPedido.toString().split("-")[0];
      const pedido = await CarrinhoService.GetPedidoVendaDireta({
        apiUrl: this.$apiUrl,
        codigoPedido: pev_codigo,
      });

      return pedido.PevPropostaSolAgora;
    },

    async nextStep() {
      await this.getToken();

      if (this.currentStep < this.lastStep) this.currentStep++;

      switch (this.currentStep) {
        case 1:
          this.step1();
          break;
      }
    },

    previousStep(step = null) {
      if (this.currentStep == this.lastStep) return;

      if (step != null) {
        this.currentStep = step;
        return;
      }
      if (this.currentStep > 1) this.currentStep--;
    },

    step1: function () {
      this.currentStep = 1;
    },

    getToken: async function () {
      const res = await SolAgoraService.GetToken({ apiUrl: this.$apiUrl });

      if (!res) {
        swal({
          title: "Aviso",
          text: respostaPadraoErroGenerico,
          icon: "warning",
        });
        return false;
      }

      this.token = res.data.AccessToken;
    },

    updateConsumerData: function (consumerData) {
      this.cepCobranca = consumerData.cep;
      this.idProject = consumerData.idProject;
    },

    setResultadoSimulacao: function (resultadoSimulacao) {
      this.resultadoSimulacao = resultadoSimulacao;
    },

    setResultadoProposta: function (resultadoProposta) {
      this.resultadoProposta = resultadoProposta;
    },
  },
  watch: {
    visible: function (val) {
      if (val) {
        this.load();
      }
    },
    total: async function (val) {
      await this.previousStep(1);
    },
  },
};
</script>